import React, { useState } from "react";
import "../componentCss/webform.css";
import "../componentCss/sidebar.css";
import "react-toastify/dist/ReactToastify.css";
import DataTable from 'react-data-table-component';
import { Modal, Button, Form } from 'react-bootstrap';
import {
  updateRxStatusAction
} from "../../Action/admin.action";
import toast, { Toaster } from "react-hot-toast";
import propertise from "../../config/properties";

const moment = require('moment');

const PrescriptionList = ({ medPassDrugAssignedList, getPrescriptionAssignListAPI }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [selectedRx, setSelectedRx] = useState(null);
  const [showStopModal, setShowStopModal] = useState(false);
  const [stopReason, setStopReason] = useState("");
  const [selectedStopRx, setSelectedStopRx] = useState(null);

  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };

  const handleViewRxDetails = (drugData) => {
    try {
      if (drugData.rxData) {
        const parsedRxData = JSON.parse(drugData.rxData);
        const selectedRxItem = JSON.parse(parsedRxData).find(item => item.id === drugData.drugId);

        setSelectedRx(selectedRxItem);
        setShowModal(true);
      }
    } catch (error) {
    }
  };

  const handleStopClick = (row) => {
    setSelectedStopRx(row);
    setShowStopModal(true);
  };

  const handleStopSubmit = async (status, id) => {

    if (!stopReason.trim() && status == 0) {
      toast.error("Please enter a reason for stopping the prescription.");
      return;
    }

    let res = await updateRxStatusAction({ status: status, id: id, stopReason: stopReason, formId: propertise.medPassDrugFormId });
    if (res.success) {
      toast.success(res.msg);
      getPrescriptionAssignListAPI();
      setShowStopModal(false);
      setStopReason("");
    } else {
      toast.error(res.msg);
    }
  };

  const columns = [
    {
      name: '#',
      cell: (row, index) => index + 1 + currentPage * rowsPerPage,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: 'Physician Name',
      selector: row => row.physicianname,
      width: "17%"
    },
    {
      name: 'Drug Name',
      selector: row => row.drugName,
      sortable: true,
      width: "17%"
    },
    {
      name: 'Drug Code',
      selector: row => row.drugCode,
      width: "17%"
    },
    {
      name: 'Rx Start/Cut Datetime',
      selector: row => (
        <>
          {moment(row.rxStartDate).format("YYYY-MM-DD")} {row.rxStartTime} - {moment(row.rxCutDate).format("YYYY-MM-DD")} {row.rxCutTime}
        </>
      ),
      width: "35%"
    },
    {
      name: 'Dosage Type',
      selector: row => row.dosagetype,
      width: "15%"
    },
    {
      name: 'Dosage Quantity',
      selector: row => row.dosagequantity,
      width: "15%"
    },
    {
      name: 'Units',
      selector: row => row.units,
      width: "10%"
    },
    {
      name: 'Status',
      selector: row => (
        <span className={row.status == 1 ? "text-success fw-bold" : "text-danger fw-bold"}>
          {row.status == 1 ? "Running" : "Stopped"}
        </span>
      )
    },
    // {
    //   name: 'Time',
    //   selector: row => (
    //     <>
    //       {
    //         JSON.parse(row?.schedulingDates).length > 0 && JSON.parse(row?.administeringCustomTimesData).length > 0 ?
    //           startReverseTimer(row?.schedulingDates, row?.administeringCustomTimesData)
    //           : ""
    //       }

    //     </>
    //   )
    // },
    {
      name: 'Action',
      selector: row => (
        <>
          <button className="btn btn-sm btn-primary" onClick={() => handleViewRxDetails(row)}>
            View Rx Details
          </button>
          &nbsp;&nbsp;
          {row.status == 1 ? (
            <button className="btn btn-sm btn-danger" onClick={() => handleStopClick(row)}>
              Stop
            </button>
          ) : (
            <button className="btn btn-sm btn-primary" onClick={() => handleStopSubmit(1, row.id)}>
              Activate
            </button>
          )}
        </>
      ),
      width: "25%"
    },
  ];

  // function startReverseTimer(dates, times) {
  //   const now = new Date();
  //   const todayStr = now.toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  //   if (!dates.includes(todayStr)) return; // If today is not in the dates array, exit

  //   const currentTime = now.getHours() * 60 + now.getMinutes(); // Convert current time to minutes

  //   // Find the earliest valid time in the array that is still ahead of current time
  //   const upcomingTime = times
  //     .map(time => {
  //       const [hours, minutes] = time.split(":").map(Number);
  //       return hours * 60 + minutes;
  //     })
  //     .find(timeInMinutes => currentTime < timeInMinutes);

  //   if (!upcomingTime) return; // No upcoming time found

  //   // Start a reverse timer for 2 hours
  //   let countdown = 2 * 60 * 60; // 2 hours in seconds

  //   function updateTimer() {
  //     if (countdown <= 0) {
  //       clearInterval(interval);
  //       return;
  //     }
  //     const hours = Math.floor(countdown / 3600);
  //     const minutes = Math.floor((countdown % 3600) / 60);
  //     const seconds = countdown % 60;
  //     countdown--;
  //   }

  //   updateTimer(); // Call immediately
  //   const interval = setInterval(updateTimer, 1000); // Update every second
  // }

  return (
    <>
      {medPassDrugAssignedList?.length > 0 ?
        <div>
          <DataTable
            columns={columns}
            data={medPassDrugAssignedList}
            pagination
            paginationPerPage={rowsPerPage}
            paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
            paginationComponentOptions={{
              rowsPerPageText: 'Row per page:',
              rangeSeparatorText: 'out of',
            }}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
          />
        </div>
        :
        <div style={{ textAlign: 'center' }}>
          No Data Found
        </div>
      }

      {/* Modal for Stop Confirmation */}
      <Modal show={showStopModal} onHide={() => setShowStopModal(false)} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger fw-bold">Stop Prescription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to stop this prescription?</p>
          <Form>
            <Form.Group controlId="stopReason">
              <Form.Label><strong>Reason for Stopping:</strong></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter reason..."
                value={stopReason}
                onChange={(e) => setStopReason(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowStopModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => handleStopSubmit(0, selectedStopRx.id)}>
            Stop Prescription
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Rx Details */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary fw-bold">Rx Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRx ? (
            <div className="container">
              <div className="row mb-3">
                <div className="col-md-6">
                  <p><strong className="text-secondary">Drug Code:</strong> {selectedRx.drugcode || 'NA'}</p>
                </div>
                <div className="col-md-6">
                  <p><strong className="text-secondary">Package Name:</strong> {selectedRx.packagename || 'NA'}</p>
                </div>
              </div>

              <div className="card shadow-sm p-3">
                <h5 className="text-primary border-bottom pb-2">Prescription Details</h5>
                <ul className="list-unstyled mt-3">
                  {Object.entries(selectedRx.rxData).map(([key, value], index) => (
                    <li key={index} className="d-flex">
                      <span className="text-secondary fw-bold col-5">{key}:</span>
                      <span className="text-dark col-7">{value}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            <p className="text-center text-danger">No details available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PrescriptionList;